export default __webpack_public_path__ + "static/ProzaLibre-Regular-4805a20f13bf01f19096a4cad3bfe084.ttf";